import React from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { destroyCategory, fetchCategories } from "../../../../actions/sticker_maker/categoriesActions";
import { CategoryInterface, setEditId } from "../../../../store/sticker_maker/categoriesSlice";

import { message } from "antd";
import ListVertical from "../../../../componets/ListVertical";
import { ButtonDestroy, ButtonEdit } from "../../../../componets/Buttons";

const _ListItem = ({ category, activeId }: { category: CategoryInterface | undefined; activeId?: number}) => {
  const dispatch = useAppDispatch();
  const options = [
    <ButtonEdit key={`edit-${category?.id}`} onClick={onClickEdit} />,
    <ButtonDestroy key={`destroy-${category?.id}`} onClick={onClickDestroy} />
  ]

  function onClickEdit() {
    if (category) {
      dispatch(setEditId(category.id));
    }
  }

  function onClickDestroy() {
    if (category) {
      handleDestroy(category.id).catch(console.error);
    }
  }

  async function handleDestroy(id: any) {
    const resultAction = await dispatch(destroyCategory(id));

    if (!category) {
      return;
    }

    if (destroyCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target: category.target }));
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyCategory.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  if (!category) {
    return null;
  }

  return (
    <ListVertical.Item
      key={category.id}
      active={category.id === activeId}
      image={category.image_url}
      options={{
        options,
        placement: 'leftTop'
      }}
    >
      {category.name}
    </ListVertical.Item>
  )
}

export default _ListItem;
